<template lang="pug" src="@/extensions/shop/views/Product/Form/Partials/price.pug"></template>

<script>
import pinia from '@/pinia';
import { useShopArticleStore } from '@/stores';

import Price from '@/extensions/shop/views/Product/Form/Partials/Price';

export default {
    name: 'ArticlePrice',
    extends: Price,
    computed: {
        shopArticleStore() {
            return useShopArticleStore(pinia);
        },
        options() {
            return this.shopArticleStore.options;
        }
    },
    methods: {
        deletePrice(payload) {
            this.shopArticleStore.deleteFormPrice(payload);
        },
        updatePrice(payload) {
            this.shopArticleStore.updateFormPrice(payload);
        }
    }
};
</script>
